// Previa mobile ao vivo do link na bio: mesmas cores (tabela do shared) e raio
// de botao do Worker publico, num quadro de celular.

import { BIO_BUTTON_RADIUS, BIO_THEME_PALETTES, SOCIAL_LABELS, SOCIAL_NETWORKS, type BioLink, type BioPageSettings } from "@lucralink/shared";

interface BioPreviewProps {
  readonly settings: BioPageSettings;
  readonly links: readonly BioLink[];
}

export function BioPreview({ settings, links }: BioPreviewProps): JSX.Element {
  const palette = BIO_THEME_PALETTES[settings.theme];
  const active = links.filter((l) => l.isActive);
  const socials = SOCIAL_NETWORKS.filter((n) => typeof settings.socials[n] === "string" && settings.socials[n]!.length > 0);
  return (
    <div className="mx-auto w-[300px] rounded-[2.2rem] border-[10px] border-neutral-900 bg-neutral-900 shadow-xl" aria-label="Prévia no celular">
      <div className="h-[560px] overflow-y-auto rounded-[1.6rem] px-4 py-6" style={{ background: palette.bg, color: palette.text }}>
        {settings.logoUrl && (
          <img src={settings.logoUrl} alt="" className="mx-auto mb-2 h-16 w-16 rounded-full object-cover" style={{ border: `2px solid ${palette.accent}` }} />
        )}
        <p className="text-center text-lg font-bold">{settings.title || "Seu nome"}</p>
        {settings.description && (
          <p className="mt-1 text-center text-xs" style={{ color: palette.muted }}>
            {settings.description}
          </p>
        )}
        {socials.length > 0 && (
          <div className="mt-3 flex flex-wrap justify-center gap-1.5">
            {socials.map((n) => (
              <span key={n} className="rounded-full px-2 py-0.5 text-[10px]" style={{ background: palette.surface, border: `1px solid ${palette.border}` }}>
                {SOCIAL_LABELS[n]}
              </span>
            ))}
          </div>
        )}
        <div className="mt-5 flex flex-col gap-2.5">
          {active.length === 0 && (
            <p className="text-center text-xs" style={{ color: palette.muted }}>
              Seus links aparecem aqui.
            </p>
          )}
          {active.map((link) => (
            <span
              key={link.id}
              className="block px-3 py-3 text-center text-sm font-bold"
              style={{ background: palette.accent, color: palette.accentInk, borderRadius: BIO_BUTTON_RADIUS[settings.buttonStyle] }}
            >
              {link.title}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
